export default __webpack_public_path__ + "static/media/unassigned.cb98476e.svg";